import { CNavbar } from './CNavbar.js';
import { CNavbarBrand } from './CNavbarBrand.js';
import { CNavbarNav } from './CNavbarNav.js';
import { CNavbarText } from './CNavbarText.js';
import { CNavbarToggler } from './CNavbarToggler.js';

const CNavbarPlugin = {
    install: (app) => {
        app.component(CNavbar.name, CNavbar);
        app.component(CNavbarBrand.name, CNavbarBrand);
        app.component(CNavbarNav.name, CNavbarNav);
        app.component(CNavbarText.name, CNavbarText);
        app.component(CNavbarToggler.name, CNavbarToggler);
    },
};

export { CNavbar, CNavbarBrand, CNavbarNav, CNavbarPlugin, CNavbarText, CNavbarToggler };
//# sourceMappingURL=index.js.map
